'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _changeProviderCompare = require('./changeProviderCompare.scss');

var _changeProviderCompare2 = _interopRequireDefault(_changeProviderCompare);

var _ComparisonTable = require('./comparisonTable/ComparisonTable.js');

var _ComparisonTable2 = _interopRequireDefault(_ComparisonTable);

var _BackCloseHeader = require('./BackCloseHeader.js');

var _BackCloseHeader2 = _interopRequireDefault(_BackCloseHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types */
exports.default = function (props) {
  var providers = props.providers,
      learnMore = props.learnMore,
      openSupportDialog = props.openSupportDialog,
      onClose = props.onClose,
      onBack = props.onBack,
      t = props.t;


  return _react2.default.createElement(
    'div',
    { className: _changeProviderCompare2.default.container },
    _react2.default.createElement(_BackCloseHeader2.default, { onClose: onClose, onBack: onBack, t: t }),
    _react2.default.createElement(_ComparisonTable2.default, {
      providers: providers,
      learnMore: learnMore,
      openSupportDialog: openSupportDialog,
      t: t,
      comparisonRows: [{
        text: t.getByKey('ChangeProvider_Comparison_Chart_List_DigitalFiles_Label'),
        key: 'sellDigitalImagesFiles',
        subCompare: [{
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Quality_Label'),
          key: 'highQualityFileDownloads'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Custom_Label'),
          key: 'customMadeImageLicenses'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Commission_Label'),
          key: 'commitionFree'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Transaction_Label'),
          key: 'noTransactionFee'
        }]
      }, {
        text: t.getByKey('ChangeProvider_Comparison_Chart_List_Physical_Goods_Label'),
        key: 'fullServiceProductPrinting',
        subCompare: [{
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Canvas_Label'),
          key: 'canvasWraps'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Photo_Label'),
          key: 'photoPrints'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Phone_Label'),
          key: 'phoneCases'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_AcrylicPrint_Label'),
          key: 'acrylicPrints'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Tote_Label'),
          key: 'toteBags'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Posters_Label'),
          key: 'artPosters'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Framed_Label'),
          key: 'framedPrints'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Pillows_Label'),
          key: 'pillows'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Metal_Label'),
          key: 'metalPrints'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_AcrylicBlocks_Label'),
          key: 'acrylicBlocks'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Mugs_Label'),
          key: 'ceramicMugs'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_Fee_Label'),
          key: 'fulfilmentfee'
        }]
      }, {
        text: t.getByKey('ChangeProvider_Comparison_Chart_List_Support_Label'),
        key: 'Support247'
      }, {
        text: t.getByKey('ChangeProvider_Comparison_Chart_List_Payments_Label'),
        key: 'payments',
        subCompare: [{
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_CreditCard_Label'),
          key: 'creditCardPaymentsAccepted'
        }, {
          text: t.getByKey('ChangeProvider_Comparison_Chart_List_PayPal_Label'),
          key: 'payPalConnection'
        }]
      }, {
        text: t.getByKey('ChangeProvider_Comparison_Chart_List_Shipping_Label'),
        key: 'international'
      }]
    })
  );
};
/* eslint-enable react/prop-types */